import _ from 'underscore'
import {storage} from '../utils'
import {reducers} from '../reducers'
const STATE_STORAGE_VERSION = '1.0'

var statestorage = {
  _save(state,{type},preState) {
    let keys = Object.keys(state)
    keys.forEach(key=>{
      if(state[key]!==preState[key] && key !=='notify'){
        // console.log('saveStateToStorage',key,type)
        storage.set(key,state[key])
      }
    })
    delete this.preStateSave
  },
  save(state,action,preState) {
    this.preStateSave = this.preStateSave || preState
    this._save(state,action,this.preStateSave)
  },
  checkversion() {
    // if(storage.get('STATE_STORAGE_VERSION') !== STATE_STORAGE_VERSION){
    //   console.log('STATE_STORAGE_VERSION not match')
    //   Object.keys(reducers).forEach(key=>{
    //     storage.remove(key)
    //   })
    //   storage.set('STATE_STORAGE_VERSION',STATE_STORAGE_VERSION)
    // }
  },
  load() {
    this.checkversion()
    let state = {}
    Object.keys(reducers).forEach(key=>{
      let value = storage.get(key)
      if(value) state[key] = value
    })
    console.log('getStateFromStorage',state)
    return state
  }
}

statestorage._save = _.debounce(statestorage._save,1000)

export function getStateFromStorage() {
  return statestorage.load()
}

export function saveStateToStorage() {
  return ({ getState }) => (next) => (action) => {
    let preState = getState()
    let returnedValue = next(action)
    let state = getState()
    if(preState !== state){
      statestorage.save(state,action,preState)
    }
    return returnedValue
  }
}




/** WEBPACK FOOTER **
 ** ./src/app/middleware/statestorage.js
 **/